(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-parallax-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var rellax = new Rellax('.es-parallax .background-image-container img', {
      center:true,
      horizontal:true
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    (() => {
      const thumbs = new Swiper('.es-testimonial-texts', {
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 600,
      });

      const slider = new Swiper('.es-testimonial-medias', {
        slidesPerView: 'auto',
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        watchSlidesProgress: true,
        on: {
          slideChange(sw) {
            thumbs.slideTo(sw.realIndex);
          },
        },
      });

      /* slider.on('click', (sw) => {
        if (!sw.clickedSlide) return;
        const realIndex = parseInt(sw.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (!isNaN(realIndex)) {
          sw.slideToLoop(realIndex);
        }
      }); */
    })()
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
